import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	close: {
		id: 'portfolio-3-create-new-plan-wizard-drawer.ui.close',
		defaultMessage: 'Close',
		description: 'Label for the button which closes drawer for create new plan wizard',
	},
	dialogLabel: {
		id: 'portfolio-3-create-new-plan-wizard-drawer.ui.dialogLabel',
		defaultMessage: 'Create a plan',
		description: 'Label for the dialog containing the create new plan wizard',
	},
});
